export const StatusData = [{ _id: '1', name: 'Active' }, { _id: '0', name: 'Inactive' }];
export const formatStatus = (value) => String(value) === '1' ? 'Active' : 'Inactive';
export const formatPermissions = (items) => items?.length ? items.map((item) => item.name).join(', ') : 'N/A';
